<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KCAxIE/image/cover.jpg?1718046260147" alt="This image is the cover for the book Girls and Goddesses, World of Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Girls and Goddesses, World of Stories
      </h1>
      <p class="bookDescription body article font2">
        <p>Greedy giants, cruel emperors, and shape-shifting demons—the stuff a girl has to put up with! Explore girl power in all its glory with stories of heroines from around the world. Myths and legends from the United States to Japan and Venezuela celebrate the courage of women and girls who rise to the occasion. With heroines like these, who needs a handsome prince?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lari Don, Francesca Greenwood
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Darby Creek
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a12ea3a6